import React from 'react'

import { Button, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'

function Footer({
  isSignup, canSubmit, onSwitchMode,
}) {
  const switchPrompt = isSignup ? 'Already a member?' : 'New here?'
  const switchLink = isSignup ? 'Log in' : 'Create an account'

  return (
    <div className={classnames(
      'auth-modal__footer',
      isSignup ? 'auth-modal__footer--signup' : 'auth-modal__footer--login'
    )}
    >
      <Button
        actionType="submit"
        size="medium"
        disabled={!canSubmit}
        customClass="auth-modal__submit"
      >
        Continue with email
      </Button>

      <p className="auth-modal__switch cgt-body-base">
        {switchPrompt}
        {' '}
        <button
          type="button"
          className="auth-modal__switch-link cgt-body-md-semibold cgt-link-primary-accented"
          onClick={onSwitchMode}
        >
          {switchLink}
        </button>
      </p>
    </div>
  )
}

Footer.propTypes = {
  isSignup: bool.isRequired,
  canSubmit: bool.isRequired,
  onSwitchMode: func.isRequired,
}

export default Footer
